module.exports = __webpack_public_path__ + "img/icon-clipboard.f1e8920e.svg";